import i18n from '@/plugins/i18n';
import { LOCALE_HEADER, LOCALE_QUERY_PARAM } from '@/constants/locale-constants';

/**
 * Idioma da tela em todo pedido: o backend põe esse idioma no link externo que gerar
 * (ficha, documentos, aprovação), para o cliente abrir no idioma de quem gerou.
 */
export function withLocaleHeader(config) {
  config.headers = config.headers || {};
  config.headers[LOCALE_HEADER] = i18n.locale;

  return config;
}

/**
 * Link externo montado no front (selfie, cadastro do corban): leva em ?lang= o idioma de quem vai
 * abrir, quando se sabe (cliente argentino em espanhol), ou o da tela.
 */
export function withLocaleQuery(url, recipientLocale = null) {
  if (!url) return url;

  return `${url}${url.includes('?') ? '&' : '?'}${LOCALE_QUERY_PARAM}=${encodeURIComponent(recipientLocale || i18n.locale)}`;
}
